import { useState } from "react";
import pmManagerShot from "../assets/screenshots/website-pm-manager.jpeg";
import cmManagerShot from "../assets/screenshots/website-cm-manager.jpeg";
import biManagerShot from "../assets/screenshots/website-bi-manager.jpeg";

export default function InteractiveVisualizer() {
  const [activeTab, setActiveTab] = useState("pm");

  return (
    <section id="visualizer" style={{ maxWidth: 960, margin: "0 auto 4rem", padding: "0 20px" }}>
      {/* Browser Mockup Container */}
      <div
        className="glass-card"
        style={{
          borderRadius: "var(--radius-lg)",
          overflow: "hidden",
          border: "1px solid var(--border-strong)",
          boxShadow: "var(--shadow-lg)",
        }}
      >
        {/* Browser Top Bar */}
        <div
          style={{
            background: "var(--surface-2)",
            padding: "12px 18px",
            borderBottom: "1px solid var(--border)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Windows/Mac Dots */}
          <div style={{ display: "flex", gap: 6 }}>
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#FF5F56", display: "inline-block" }} />
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#FFBD2E", display: "inline-block" }} />
            <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#27C93F", display: "inline-block" }} />
          </div>

          {/* Tab Controls */}
          <div style={{ display: "flex", gap: 6, background: "var(--surface-1)", padding: 4, borderRadius: 8 }}>
            <button
              onClick={() => setActiveTab("pm")}
              style={{
                background: activeTab === "pm" ? "var(--surface-0)" : "transparent",
                color: activeTab === "pm" ? "var(--navy)" : "var(--text-secondary)",
                border: "none",
                padding: "6px 14px",
                borderRadius: 6,
                fontSize: 12,
                fontWeight: activeTab === "pm" ? 600 : 500,
              }}
            >
              PM Manager
            </button>
            <button
              onClick={() => setActiveTab("cm")}
              style={{
                background: activeTab === "cm" ? "var(--surface-0)" : "transparent",
                color: activeTab === "cm" ? "var(--navy)" : "var(--text-secondary)",
                border: "none",
                padding: "6px 14px",
                borderRadius: 6,
                fontSize: 12,
                fontWeight: activeTab === "cm" ? 600 : 500,
              }}
            >
              CM Manager
            </button>
            <button
              onClick={() => setActiveTab("bi")}
              style={{
                background: activeTab === "bi" ? "var(--surface-0)" : "transparent",
                color: activeTab === "bi" ? "var(--navy)" : "var(--text-secondary)",
                border: "none",
                padding: "6px 14px",
                borderRadius: 6,
                fontSize: 12,
                fontWeight: activeTab === "bi" ? 600 : 500,
              }}
            >
              BI Manager
            </button>
          </div>

          {/* Invisible spacer matching the dots' width, so the tab controls stay
              centered now that there's no URL text balancing the other side. */}
          <div style={{ display: "flex", gap: 6 }} aria-hidden="true">
            <span style={{ width: 10, height: 10, borderRadius: "50%", opacity: 0, display: "inline-block" }} />
            <span style={{ width: 10, height: 10, borderRadius: "50%", opacity: 0, display: "inline-block" }} />
            <span style={{ width: 10, height: 10, borderRadius: "50%", opacity: 0, display: "inline-block" }} />
          </div>
        </div>

        {/* Browser Mockup Body View - real app screenshots, tab-matched */}
        <div style={{ background: "var(--surface-0)" }}>
          {activeTab === "pm" && (
            <img src={pmManagerShot} alt="PM Manager workbook: WBS &amp; Gantt, stakeholders, RAID register, and status reporting for a single initiative" style={{ width: "100%", display: "block" }} />
          )}
          {activeTab === "cm" && (
            <img src={cmManagerShot} alt="CM Manager: change readiness gates from Initiation through the pre-go-live resistance check, with Origin & Baseline, Team Responses, and CM Scorecard tabs" style={{ width: "100%", display: "block" }} />
          )}
          {activeTab === "bi" && (
            <img src={biManagerShot} alt="BI Manager: tier-scaled Define-Measure-Analyse-Improve-Control workflow for a business improvement initiative" style={{ width: "100%", display: "block" }} />
          )}
        </div>
      </div>
    </section>
  );
}

